<div class="personal-infomation p-4 mt-4" id="certifications">
    <div class=" d-flex justify-content-between ">
        <h2 class="profile-heading">Certifications & Licenses</h2>
        <div class="d-flex">
        <img class="edit-profile mx-1" (click)="addCertificationsAndLicense()"
            *ngIf="(endCustomerData?.certifications && this.endCustomerData.certifications.length>0) || showEditForm" alt=""
            src="../../assets/images/add.svg" id="add-icon7">
        <img class="edit-profile " (click)="editCertificationsAndLicense()"
            *ngIf="(endCustomerData?.certifications && this.endCustomerData.certifications.length>0) &&!showEditForm" alt=""
            src="../../assets/images/editprofile.svg" id="edit-icon7">
            </div>

    </div>
    <div class="mt-2" *ngIf="!(endCustomerData?.certifications && this.endCustomerData.certifications.length>0) && !showEditForm ">
        <button (click)="addCertificationsAndLicense()" class="profile-btn btn2">
            <mat-icon >add</mat-icon> <p class="ps-2" id="add-certification-details">Add Certifications & Licenses</p></button>
    </div>
    <div 
        *ngIf="(endCustomerData?.certifications && this.endCustomerData.certifications.length>0) && !showEditForm">
    <div  class="mt-2 pt-1" *ngIf="showPersonalInfo">
        <div *ngFor="let item of data">
            <div>
                <div class="d-flex align-items-center mt-3">
                    <img class="card-icon me-3" src="{{ certificateIcon }}" alt="Card Profile" />
                    <div>
                        <div style="font-weight: 600;">{{ item.name }}</div>
                        <div style="font-weight: 600;">{{ item.organizationName}}</div>
                        <div style="font-weight: 600;">{{ item.year }}</div>
                        <a style="text-decoration: none;" href="{{item.certificate}}" target="_blank" *ngIf="item.fileName">
                            <div style="color: #0d87c8;text-decoration: underline">View Certificate</div>
                        </a>
                    </div>
                </div>
            </div>
        </div>

    </div>
<div *ngIf="!showPersonalInfo">
    <app-mwe-table [showPagination]="false" [columns]="certificateColumns" [showHeader]="false"
    [data]="data" (selectedAction)="selectedAction($event)"></app-mwe-table>
</div>
        
    </div>

    <form [formGroup]="certificationsForm" class="mt-2" *ngIf="showEditForm">
        <div formArrayName="certifications">
            <div *ngFor="let certificationForm of certifications.controls;let i=index;">
                <div [formGroupName]="i">
                    <div class="row mb-4">
                        <div class="col-lg-12">
                            <div class="card">
                                <div class="row">
                                    <div class="col-lg-5 my-1">
                                        <div >
                                            <p class="med-world-basic-font med-world-basic-font__large med-world-basic-font__weight secondary_black_color m-0 mt-2">Name</p>
                                        </div>
                                        <div>
                                            <mat-form-field appearance="outline" class="fields input-font b-r w-100">
                                                <input matInput  formControlName="name" placeholder="Enter Name" (keydown)="handleKeyDown($event)">
                            <mat-error class="error-message error-msg"
                            *ngIf="certificationForm.get('name')?.hasError('pattern')|| certificationForm.get('name')?.hasError('maxlength')"><img class="error-icon"  
                                loading="lazy" alt="" src="./../../assets/images/alert.svg" /> {{certificationForm.get('name')?.hasError('pattern') ? ' Only Alphabets are allowed' : ' Limit Exceeded: Max 50 characters'}}</mat-error>
                           
                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 my-1">
                                        <div >
                                            <p class="med-world-basic-font med-world-basic-font__large med-world-basic-font__weight secondary_black_color m-0 mt-2">Organization Name</p>
                                        </div>
                                        <div>
                                            <mat-form-field appearance="outline" class="fields input-font b-r w-100">
                                                <input matInput  formControlName="organizationName" placeholder="Enter Organization Name" (keydown)="handleKeyDown($event)">
                                                
                            <mat-error class="error-message error-msg"
                            *ngIf="certificationForm.get('organizationName')?.hasError('pattern') || certificationForm.get('organizationName')?.hasError('maxlength')"><img class="error-icon"  
                                loading="lazy" alt="" src="./../../assets/images/alert.svg" /> {{certificationForm.get('organizationName')?.hasError('pattern')?' Only Alphanumerics are allowed':' Limit Exceeded: Max 150 characters'}}</mat-error>
                              
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 my-1">
                                        <div >
                                            <p class="med-world-basic-font med-world-basic-font__large med-world-basic-font__weight secondary_black_color m-0 mt-2">Year</p>
                                        </div>
                                        <div>
                                            <mat-form-field appearance="outline" class="fields input-font b-r w-50">
                                              
                                                    <input type="text" matInput placeholder="Search Year"
                                                           [matAutocomplete]="autoYear"
                                                           [formControlName]="'year'" (keydown)="handleKeyDown($event)"
                                                           (input)="filterYears(i)" (focus)="filterYears(i)" onlyNumbers maxlength="4">
                                                    <mat-autocomplete #autoYear="matAutocomplete" (optionSelected)="onYearSelected($event, i)">
                                                        <mat-option *ngFor="let year of filteredYears[i]" [value]="year">
                                                            {{ year }}
                                                        </mat-option>
                                                    </mat-autocomplete>
                                              
                                            
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="col-lg-7" [ngClass]="{'my-3': certificationForm.get('name')?.hasError('required'), 'my-1': !certificationForm.get('name')?.hasError('required')}">
                                        <div >
                                            <p class="med-world-basic-font med-world-basic-font__large med-world-basic-font__weight secondary_black_color m-0 mt-2">Certificate</p>
                                        </div>
                                        <div
                                            class="d-flex flex-wrap "
                                            [ngStyle]="{
                                                'margin-left': certificationForm.get('fileName')?.value ? '0' : '-15px'
                                            }"
                                            >

                                            <a class="file-link m-2" *ngIf="certificationForm.get('fileName')?.value" href="{{certificationForm.get('certificate')?.value}}" target="_blank">
                                                {{certificationForm.get('fileName')?.value}}
                                            </a>
                                            <div>
                                            <input class="d-none" type="file" id="{{'uploadCertificate'+i}}" accept=".png,.jpg,.jpeg,.pdf" (change)="uploadCertificate($event,i)" />
                                            <label class="mwe-button mwe-button--primary upload med-world-basic-font med-world-basic-font__medium ps-3 pe-3" for="{{'uploadCertificate'+i}}">
                                                Upload
                                            </label>
                                            <button class="mx-4 mwe-button mwe-button--secondary ps-3 pe-3" (click)="deleteCertificationsAndLicense(i)">Delete</button></div>
                                        </div>
                                        <div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="profile-action " *ngIf="showEditForm">
        <button  class="mwe-button mwe-button--primary med-world-basic-font med-world-basic-font__medium ps-3 pe-3" (click)="update()">Update</button>
        <button  class="mwe-button mwe-button--secondary ps-3 pe-3 "  (click)="cancel()">Cancel</button>
    
    </div>
</div>